import { render, staticRenderFns } from "./blog-2.vue?vue&type=template&id=2b8fc87c&scoped=true"
import script from "./blog-2.vue?vue&type=script&lang=js"
export * from "./blog-2.vue?vue&type=script&lang=js"
import style0 from "./blog-2.vue?vue&type=style&index=0&id=2b8fc87c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8fc87c",
  null
  
)

export default component.exports